import type { CrudFilter } from '@refinedev/core';
import type { SetFilters } from '@/utils/filters';

/**
 * Page-level publisher scope, owned by the switcher in a list's title.
 *
 * Reads the scope back from the `publisher_id[eq]` filter — so it survives a
 * reload via the URL — and writes it the same way; `null` means every
 * publisher. `onChange` runs before the filter is set, e.g. to clear a row
 * selection that may not be on screen under the new scope.
 */
export const usePublisherScope = (
  filters: CrudFilter[],
  setFilters: SetFilters,
  onChange?: () => void
) => {
  const publisherFilter = filters.find(
    (f) => 'field' in f && f.field === 'publisher_id' && f.value != null
  );
  const publisherId =
    publisherFilter && 'value' in publisherFilter
      ? Number(publisherFilter.value)
      : null;
  const setPublisherScope = (id: number | null) => {
    onChange?.();
    setFilters(
      [{ field: 'publisher_id', operator: 'eq', value: id ?? undefined }],
      'merge'
    );
  };
  return { publisherId, setPublisherScope };
};
